import { render, staticRenderFns } from "./ToDoListItem.vue?vue&type=template&id=46867c53&scoped=true"
import script from "./ToDoListItem.vue?vue&type=script&lang=js"
export * from "./ToDoListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46867c53",
  null
  
)

export default component.exports